(function () {
  'use strict';

  /* The widget can be rendered more than once per page. The first copy of this
     script defines everything; later copies just initialise new instances. */
  if (window.HKCF && window.HKCF.initAll) { window.HKCF.initAll(); return; }

  var DAY = 864e5;
  var DRAFT_TTL = 2 * 3600e3;          // restore unfinished forms for 2 h (tab-scoped)
  var MIN_FILL_MS = 3000;              // humans can't finish step 1 faster than this
  var STUCK_MS = 12000;                // submit still "sending" after this → give the form back
  var MAX_CAPTURES_PER_DAY = 3;        // partial-lead e-mails per browser per 24 h
  var KEY_LOG = 'hkcf_capture_log_v1'; // localStorage — 32-bit hash of the phone (dedupe only; reversible for MD numbers, so treat as personal data)
  var KEY_ATTR = 'hkcf_attrib_v1';     // sessionStorage — first-touch source of this visit
  var KEY_PENDING = 'hkcf_pending_v1'; // sessionStorage — set right before a real submit
  var KEY_DRAFT = 'hkcf_draft_v1:';    // sessionStorage — per instance + path

  var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── Storage helpers (private mode / blocked storage safe) ── */
  function getStore(kind) {
    try { var s = window[kind], k = '__hkcf'; s.setItem(k, k); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var SS = getStore('sessionStorage'), LS = getStore('localStorage');
  function jget(s, k) { if (!s) return null; try { return JSON.parse(s.getItem(k)); } catch (e) { return null; } }
  function jset(s, k, v) { if (!s) return; try { s.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function jdel(s, k) { if (!s) return; try { s.removeItem(k); } catch (e) {} }

  function fmt(str, map) {
    return String(str || '').replace(/%(\w+)%/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hash(str) { var h = 5381; for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0; return (h >>> 0).toString(36); }

  /* ── Validators ─────────────────────────────────────────── */

  /* Name / phone / e-mail rules are shared by every lead form: assets/hk-validate.js (ARCH-023),
     loaded in <head> before this file. */
  function parsePhone(raw) { return window.HKValidate.phone(raw); }
  function validName(v) { return window.HKValidate.name(v); }
  function isEmail(v) { return window.HKValidate.email(v); }

  /* IBAN: structure + country length (where known) + ISO 13616 mod-97 check. Empty = ok (field is optional). */
  var IBAN_LEN = { MD: 24, RO: 24, UA: 29, BG: 22, PL: 28, DE: 22, AT: 20, IT: 27, FR: 27, ES: 24, NL: 18, BE: 16,
                   CZ: 24, SK: 24, HU: 28, LT: 20, LV: 21, EE: 20, TR: 26, GB: 22, CH: 21, GR: 27, PT: 25 };
  function parseIban(raw) {
    var s = String(raw || '').replace(/\s+/g, '').toUpperCase();
    if (!s) return { ok: true, empty: true, value: '' };
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(s)) return { ok: false };
    var L = IBAN_LEN[s.slice(0, 2)];
    if (L && s.length !== L) return { ok: false };
    var r = s.slice(4) + s.slice(0, 4), rem = 0;
    for (var i = 0; i < r.length; i++) {
      var c = r.charCodeAt(i), chunk = c >= 65 ? String(c - 55) : r.charAt(i);
      for (var j = 0; j < chunk.length; j++) rem = (rem * 10 + (chunk.charCodeAt(j) - 48)) % 97;
    }
    return { ok: rem === 1, value: s, display: s.replace(/(.{4})/g, '$1 ').trim() };
  }

  /* "Did you mean …?" for the e-mail domains Moldovan B2B customers actually use */
  var DOMAINS = ['gmail.com', 'mail.ru', 'mail.md', 'mail.com', 'yandex.ru', 'yandex.com', 'ya.ru', 'yahoo.com',
                 'yahoo.ro', 'ymail.com', 'outlook.com', 'hotmail.com', 'live.com', 'icloud.com', 'list.ru',
                 'bk.ru', 'inbox.ru', 'rambler.ru', 'ukr.net'];
  function lev(a, b) {
    var m = a.length, n = b.length, prev = [], cur, i, j;
    for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) {
      cur = [i];
      for (j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
      prev = cur;
    }
    return prev[n];
  }
  function suggestEmail(v) {
    v = String(v || '').trim().toLowerCase();
    var at = v.lastIndexOf('@'); if (at < 1) return '';
    var dom = v.slice(at + 1); if (dom.length < 4 || DOMAINS.indexOf(dom) > -1) return '';
    var best = '', bestD = 3;
    DOMAINS.forEach(function (d) { var x = lev(dom, d); if (x < bestD) { bestD = x; best = d; } });
    return best ? v.slice(0, at + 1) + best : '';
  }

  /* ── Lead-source attribution (first touch of this visit) ── */
  function captureAttribution() {
    if (jget(SS, KEY_ATTR)) return;
    var a = { landing: location.pathname };
    try {
      var p = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) {
        var v = p.get(k); if (v) a[k] = v.slice(0, 100);
      });
    } catch (e) {}
    try {
      if (document.referrer) {
        var host = new URL(document.referrer).hostname;
        if (host && host !== location.hostname) a.ref = host;
      }
    } catch (e) {}
    jset(SS, KEY_ATTR, a);
  }
  function attributionString() {
    var a = jget(SS, KEY_ATTR) || {}, out = [];
    if (a.utm_source || a.utm_medium) out.push((a.utm_source || '?') + ' / ' + (a.utm_medium || '?'));
    if (a.utm_campaign) out.push('campaign: ' + a.utm_campaign);
    if (a.utm_term) out.push('term: ' + a.utm_term);
    if (a.gclid || a.gbraid || a.wbraid) out.push('Google Ads click');
    if (a.fbclid) out.push('Facebook click');
    if (!out.length) out.push(a.ref ? 'referral: ' + a.ref : 'direct / organic');
    if (a.landing) out.push('landing: ' + a.landing);
    return out.join(' · ');
  }

  function track(ev, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: ev, hk_form: 'contact_widget' };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (e) {}
  }

  /* ── After a successful Shopify post ─────────────────────── */
  function onPosted(root) {
    try {
      if (SS) Object.keys(SS).forEach(function (k) { if (k.indexOf(KEY_DRAFT) === 0) SS.removeItem(k); });
    } catch (e) {}
    var pend = jget(SS, KEY_PENDING);
    if (pend && !window.__hkcfPostedTracked) {
      window.__hkcfPostedTracked = true;
      jdel(SS, KEY_PENDING);
      track('hk_lead_submit', { hk_client_type: pend.type || '', hk_product: pend.product || '', hk_ref: pend.ref || '' });
    }
    var box = root.querySelector('[data-hkcf-success]');
    if (box && !window.__hkcfPostedFocused) {
      window.__hkcfPostedFocused = true;
      try { box.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* ── One widget instance ─────────────────────────────────── */
  function init(root) {
    root.setAttribute('data-hkcf-init', '');
    var cfg;
    // `| t` HTML-escapes apostrophes/quotes and `| json` keeps the entity; decode for textContent (UX-042)
    try { cfg = JSON.parse(root.querySelector('script[data-hkcf-config]').textContent, function (k, v) { return typeof v === 'string' ? v.replace(/&(#39|#x27|quot|amp|lt|gt);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', amp: '&', lt: '<', gt: '>' }[e]; }) : v; }); } catch (e) { return; }
    var T = cfg.i18n || {}; T.err = T.err || {}; T.steps = T.steps || [];

    root.addEventListener('click', function (e) {
      var tr = e.target.closest && e.target.closest('[data-hkcf-track]');
      if (tr) track('hk_contact_click', { hk_channel: tr.getAttribute('data-hkcf-track') });
    });

    if (cfg.posted) { onPosted(root); return; }

    var form = root.querySelector('form');
    if (!form || !root.querySelector('[data-hkcf-step="1"]')) return;

    root.classList.add('hkcf--js');
    form.noValidate = true;

    function $(sel) { return root.querySelector(sel); }
    function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

    var F = {};
    $$('[data-hkcf-field]').forEach(function (el) { F[el.getAttribute('data-hkcf-field')] = el; });
    var panels = {};
    $$('[data-hkcf-step]').forEach(function (p) { panels[p.getAttribute('data-hkcf-step')] = p; });

    var stepLabel = $('[data-hkcf-step-label]'), bar = $('[data-hkcf-bar]'), live = $('[data-hkcf-live]');
    var addrWrap = $('[data-hkcf-addr]'), s2Next = $('[data-hkcf-next="2"]'), submitBtn = $('[data-hkcf-submit]');
    var refInput = $('[data-hkcf-ref]'), srcInput = $('[data-hkcf-source]'), suggestBtn = $('[data-hkcf-suggest]');
    var honeypots = $$('[data-hkcf-hp]');
    var stuckEl = $('[data-hk-stuck]');
    var draftKey = KEY_DRAFT + cfg.uid + ':' + location.pathname;

    var st = { step: 1, startedAt: 0, captured: false, attempted: {}, submitting: false, ref: null };

    function radio(name) { var el = form.querySelector('input[name="contact[' + name + ']"]:checked'); return el ? el.value : ''; }
    function isCompany() { return radio('client_type') === 'company'; }
    function isDelivery() { return radio('delivery_method') === 'delivery'; }
    function total() { return isCompany() ? 3 : 2; }
    function ref() {
      if (!st.ref) {
        var d = new Date();
        st.ref = 'HK-' + String(d.getFullYear()).slice(2) + pad(d.getMonth() + 1) + pad(d.getDate()) + '-' +
                 Math.random().toString(36).slice(2, 6).toUpperCase();
      }
      return st.ref;
    }
    function announce(msg) {
      if (!live) return;
      live.textContent = '';
      setTimeout(function () { live.textContent = msg || ''; }, 60);
    }

    /* ── Errors & rules ── */
    function setError(key, msg) {
      var el = root.querySelector('[data-hkcf-err="' + key + '"]');
      var group = root.querySelector('[data-hkcf-group="' + key + '"]');
      if (el) { el.textContent = msg || ''; el.hidden = !msg; }
      if (F[key]) { if (msg) F[key].setAttribute('aria-invalid', 'true'); else F[key].removeAttribute('aria-invalid'); }
      if (group) group.classList.toggle('is-invalid', !!msg);
    }
    var rules = {
      client_type: function () { return radio('client_type') ? '' : T.err.client_type; },
      phone: function () { return parsePhone(F.phone.value).ok ? '' : T.err.phone; },
      name: function () { return validName(F.name.value) ? '' : T.err.name; },
      email: function () { return isEmail(F.email.value) ? '' : T.err.email; },
      // Optional (D12): staff can ask for the delivery address by phone. If given, at least 3 chars.
      address: function () { var v = F.address.value.trim(); return (!isDelivery() || !v || v.length >= 3) ? '' : T.err.address; },
      company: function () { return F.company.value.trim().length >= 2 ? '' : T.err.company; },
      idno: function () { return /^\d{13}$/.test(F.idno.value.replace(/\s/g, '')) ? '' : T.err.idno; },
      tva: function () { var v = F.tva.value.replace(/\s/g, ''); return (!v || /^\d{7}$/.test(v)) ? '' : T.err.tva; },
      iban: function () { return parseIban(F.iban.value).ok ? '' : T.err.iban; }
    };
    var stepFields = { 1: ['client_type', 'phone', 'name'], 2: ['email', 'address'], 3: ['company', 'idno', 'tva', 'iban'] };

    function check(key, show) { var msg = rules[key](); if (show) setError(key, msg); return !msg; }
    function stepOk(n) { return stepFields[n].every(function (k) { return check(k, false); }); }
    /* visible name of a field (its label or legend, without the * marker) for the live summary */
    function fieldName(k) {
      var lab = F[k] && F[k].id ? root.querySelector('label[for="' + F[k].id + '"]') : null;
      if (!lab) lab = root.querySelector('[data-hkcf-group="' + k + '"] legend');
      return lab ? lab.textContent.replace(/\*/g, '').replace(/\s+/g, ' ').trim() : '';
    }
    function validateStep(n) {
      var first = null, bad = [];
      stepFields[n].forEach(function (k) {
        st.attempted[k] = true;
        if (!check(k, true)) { if (!first) first = k; bad.push(k); }
      });
      if (!first) return true;
      var el = F[first] || root.querySelector('[data-hkcf-group="' + first + '"] input');
      if (el) { try { el.focus({ preventScroll: false }); } catch (e) { el.focus(); } }
      /* name the fields to fix instead of "marked in red" (A11Y-018) */
      var names = bad.map(fieldName).filter(Boolean);
      announce(names.length && T.err.summary_fields ? T.err.summary_fields.replace('__F__', names.join(', ')) : T.err.summary);
      return false;
    }

    /* ── Field tidy-up on blur ── */
    function tidy(key) {
      var el = F[key]; if (!el) return;
      if (key === 'phone') { var p = parsePhone(el.value); if (p.ok) el.value = p.display; }
      else if (key === 'name' || key === 'company' || key === 'address' || key === 'legal_address') el.value = el.value.replace(/\s+/g, ' ').trim();
      else if (key === 'email') el.value = el.value.trim();
      else if (key === 'idno' || key === 'tva') el.value = el.value.replace(/\s/g, '');
      else if (key === 'iban') { var ib = parseIban(el.value); if (ib.ok && ib.display) el.value = ib.display; else el.value = el.value.toUpperCase(); }
    }
    function showSuggest() {
      if (!suggestBtn) return;
      var s = suggestEmail(F.email.value);
      if (!s) { suggestBtn.hidden = true; return; }
      suggestBtn.textContent = fmt(T.email_suggest, { email: s });
      suggestBtn.setAttribute('data-value', s);
      suggestBtn.hidden = false;
    }
    function hideSuggest() { if (suggestBtn) suggestBtn.hidden = true; }

    /* ── UI state ── */
    function renderProgress() {
      var n = st.step, t = total();
      if (stepLabel) stepLabel.textContent = fmt(T.step_of, { current: n, total: t }) + (T.steps[n - 1] ? ' · ' + T.steps[n - 1] : '');
      if (bar) bar.style.width = Math.round(n / t * 100) + '%';
    }
    function updateType() {
      var company = isCompany();
      if (s2Next) {
        var lbl = s2Next.querySelector('[data-hkcf-label]');
        if (lbl && !st.submitting) lbl.textContent = company ? T.continue : T.submit;
        s2Next.classList.toggle('is-final', !company);
      }
      renderProgress();
    }
    function syncAddr() {
      var on = isDelivery();
      if (addrWrap) addrWrap.hidden = !on;
      if (F.address) F.address.required = false;
      if (!on) setError('address', '');
    }
    function showStep(n, moveFocus) {
      Object.keys(panels).forEach(function (k) { panels[k].hidden = (+k !== n); });
      st.step = n;
      renderProgress();
      saveDraft();
      if (moveFocus === false) return;
      var r = root.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) {
        try { root.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' }); } catch (e) { root.scrollIntoView(); }
      }
      var h = panels[n] && panels[n].querySelector('[data-hkcf-step-title]');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) {} }
      announce(stepLabel ? stepLabel.textContent : '');
    }
    function setLoading(on) {
      [submitBtn, s2Next].forEach(function (b) {
        if (!b) return;
        var lbl = b.querySelector('[data-hkcf-label]');
        if (on) {
          if (lbl) { b.setAttribute('data-hkcf-orig', lbl.textContent); lbl.textContent = T.sending || '…'; }
          b.disabled = true; b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true');
        } else {
          if (lbl && b.hasAttribute('data-hkcf-orig')) lbl.textContent = b.getAttribute('data-hkcf-orig');
          b.disabled = false; b.classList.remove('is-loading'); b.removeAttribute('aria-busy');
        }
      });
    }

    /* ── Drafts (sessionStorage: survives reload / Shopify error page, dies with the tab) ── */
    var saveTimer = null;
    function collect() {
      var d = {};
      Object.keys(F).forEach(function (k) { d[k] = F[k].value; });
      ['client_type', 'delivery_method', 'payment_method'].forEach(function (n) { d['r_' + n] = radio(n); });
      return d;
    }
    function saveDraft() {
      if (!st.startedAt && !jget(SS, draftKey)) return;
      jset(SS, draftKey, { t: Date.now(), step: st.step, ref: st.ref, cap: st.captured, d: collect() });
    }
    function saveSoon() { clearTimeout(saveTimer); saveTimer = setTimeout(saveDraft, 400); }
    function restoreDraft() {
      var s = jget(SS, draftKey);
      if (!s || !s.d) return 0;
      if (Date.now() - s.t > DRAFT_TTL) { jdel(SS, draftKey); return 0; }
      Object.keys(s.d).forEach(function (k) {
        var v = s.d[k];
        if (k.indexOf('r_') === 0) {
          if (v && /^[a-z_]+$/.test(v)) {
            var r = form.querySelector('input[name="contact[' + k.slice(2) + ']"][value="' + v + '"]');
            if (r) r.checked = true;
          }
        } else if (F[k] && typeof v === 'string') {
          F[k].value = v;
        }
      });
      if (s.ref) st.ref = s.ref;
      if (s.cap) st.captured = true;
      st.startedAt = s.t;
      var target = Math.min(s.step || 1, total());
      for (var n = 1; n < target; n++) { if (!stepOk(n)) { target = n; break; } }
      return target;
    }

    /* ── Partial lead (step 1) — hardened ── */
    function capture(trusted) {
      var c = cfg.capture || {};
      if (!c.enabled || !c.key || !c.url || st.captured) return;
      if (!trusted) return;                                                        // scripted .click()
      if (honeypots.some(function (el) { return el.type === 'checkbox' ? el.checked : el.value; })) return;
      if (!st.startedAt || Date.now() - st.startedAt < MIN_FILL_MS) return;        // too fast for a human
      var p = parsePhone(F.phone.value); if (!p.ok) return;
      if (!window.fetch || !window.FormData) return;

      var now = Date.now(), ph = hash(p.e164);
      var log = (jget(LS, KEY_LOG) || []).filter(function (x) { return x && now - x.t < DAY; });
      if (log.some(function (x) { return x.p === ph; })) { st.captured = true; return; } // already sent for this number
      if (log.length >= MAX_CAPTURES_PER_DAY) return;

      st.captured = true;
      var name = F.name.value.replace(/\s+/g, ' ').trim();
      var fd = new FormData();
      fd.append('access_key', c.key);
      fd.append('subject', '[HK Lead parțial] ' + ref() + ' · ' + name + ' · ' + p.e164);
      fd.append('from_name', 'HK Lead Capture');
      fd.append('name', name);
      fd.append('phone', p.e164);
      fd.append('message', [
        'Referință: ' + ref(),
        'Produs: ' + (cfg.product || '-'),
        'Pagina: ' + (cfg.page || location.href),
        'Tip client: ' + (isCompany() ? 'Persoană juridică' : 'Persoană fizică'),
        'Telefon: ' + p.display,
        'Nume: ' + name,
        'Sursa: ' + attributionString(),
        'Timp completare pas 1: ' + Math.round((now - st.startedAt) / 1000) + ' s',
        '',
        'Clientul a completat doar pasul 1. Dacă sosește și cererea completă cu aceeași referință, acest e-mail poate fi ignorat.'
      ].join('\n'));

      function done(ok) {
        if (ok) {
          log.push({ t: now, p: ph }); jset(LS, KEY_LOG, log);
          track('hk_lead_partial', { hk_client_type: radio('client_type'), hk_product: cfg.product || '' });
        } else {
          st.captured = false;
        }
        saveDraft();
      }
      try {
        fetch(c.url, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, keepalive: true })
          .then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
          .then(function (d) { done(!!(d && d.success)); }, function () { done(false); });
      } catch (e) { done(false); }
    }

    /* ── Navigation ── */
    function doSubmit() {
      if (form.requestSubmit) form.requestSubmit(submitBtn);
      else submitBtn.click();
    }
    function next(from, trusted) {
      if (st.submitting) return;
      if (from === 1) { if (!validateStep(1)) return; capture(trusted); showStep(2); return; }
      if (from === 2) { if (!validateStep(2)) return; if (isCompany()) { showStep(3); return; } doSubmit(); return; }
      if (from === 3) { doSubmit(); }
    }

    function finalize() {
      var p = parsePhone(F.phone.value); if (p.ok) F.phone.value = p.e164;
      if (!isDelivery()) F.address.value = '';
      if (!isCompany()) ['company', 'idno', 'tva', 'legal_address', 'iban'].forEach(function (k) { if (F[k]) F[k].value = ''; });
      if (F.idno) F.idno.value = F.idno.value.replace(/\s/g, '');
      if (F.tva) F.tva.value = F.tva.value.replace(/\s/g, '');
      var ib = parseIban(F.iban.value); if (ib.value) F.iban.value = ib.value;
      if (!F.message.value.trim() && T.default_message) F.message.value = T.default_message;
      if (refInput) refInput.value = ref();
      if (srcInput) srcInput.value = attributionString();
      jset(SS, KEY_PENDING, { t: Date.now(), type: radio('client_type'), product: cfg.product || '', ref: ref() });
      saveDraft();
    }

    /* Single gate for every way the form can be submitted: buttons, Enter key,
       requestSubmit, or the hidden submit in step 3. Capture phase, so it runs
       before Shopify's own hCaptcha handler and can stop it on invalid data. */
    form.addEventListener('submit', function (e) {
      if (st.submitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var steps = isCompany() ? [1, 2, 3] : [1, 2], bad = 0;
      for (var i = 0; i < steps.length; i++) { if (!stepOk(steps[i])) { bad = steps[i]; break; } }
      if (bad) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (st.step !== bad) showStep(bad, false);
        validateStep(bad);
        return;
      }
      finalize();
      st.submitting = true;
      setLoading(true);
      if (stuckEl) stuckEl.hidden = true;
      st.submitAt = Date.now();
      clearTimeout(st.watchdog);
      st.watchdog = setTimeout(unstick, STUCK_MS);
    }, true);

    /* Watchdog: Shopify's hCaptcha takes over the submit and only navigates when the challenge
       passes. If it was closed or failed to load, the page is still here after STUCK_MS: give the
       buttons back (values kept) and show the phone / WhatsApp line. */
    function unstick() {
      if (!st.submitting || document.visibilityState !== 'visible') return;
      st.submitting = false;
      setLoading(false);
      updateType();
      if (stuckEl) stuckEl.hidden = false;
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && st.submitting && Date.now() - st.submitAt > STUCK_MS) unstick();
    });

    /* ── Events ── */
    function markStarted() { if (!st.startedAt) st.startedAt = Date.now(); }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var nx = t.closest('[data-hkcf-next]');
      if (nx) { e.preventDefault(); next(+nx.getAttribute('data-hkcf-next'), e.isTrusted); return; }
      var bk = t.closest('[data-hkcf-back]');
      if (bk) { e.preventDefault(); showStep(+bk.getAttribute('data-hkcf-back')); return; }
      if (suggestBtn && t.closest('[data-hkcf-suggest]')) {
        F.email.value = suggestBtn.getAttribute('data-value') || F.email.value;
        hideSuggest(); st.attempted.email = true; check('email', true); F.email.focus(); saveSoon();
      }
    });

    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;           // textarea / buttons keep native Enter
      e.preventDefault();
      next(st.step, e.isTrusted);
    });

    form.addEventListener('focusin', markStarted);
    form.addEventListener('input', function (e) {
      markStarted();
      var k = e.target.getAttribute && e.target.getAttribute('data-hkcf-field');
      if (k && st.attempted[k]) check(k, true);
      if (k === 'email') hideSuggest();
      saveSoon();
    });
    form.addEventListener('change', function (e) {
      markStarted();
      var n = e.target.name;
      if (n === 'contact[client_type]') { updateType(); if (st.attempted.client_type) check('client_type', true); }
      if (n === 'contact[delivery_method]') syncAddr();
      saveSoon();
    });
    form.addEventListener('focusout', function (e) {
      var k = e.target.getAttribute && e.target.getAttribute('data-hkcf-field');
      if (!k || !rules[k] && k !== 'legal_address') { return; }
      tidy(k);
      if (rules[k] && e.target.value.trim()) { st.attempted[k] = true; check(k, true); }
      if (k === 'email') showSuggest();
    });

    /* Back/forward cache: never leave the buttons stuck in "sending" */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && st.submitting) { st.submitting = false; setLoading(false); updateType(); }
    });

    /* ── Start ── */
    captureAttribution();
    var startStep = restoreDraft();
    updateType();
    syncAddr();
    showStep(startStep || 1, false);
  }

  window.HKCF = {
    initAll: function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-hkcf]:not([data-hkcf-init])')).forEach(init);
    },
    _test: { parsePhone: parsePhone, validName: validName, isEmail: isEmail, parseIban: parseIban, suggestEmail: suggestEmail }
  };
  window.HKCF.initAll();
})();
